"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const react_query_2 = require("react-query");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const FormalReviewClient_1 = require("client/FormalReviewClient");
const HelperUtils_1 = require("utils/HelperUtils");
const socket_1 = require("utils/socket");
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const CalibrationModal_1 = __importDefault(require("components/formal-review/calibration/CalibrationModal"));
const CalibrationHistorySidebar_1 = __importDefault(require("components/formal-review/evidence-sidebar/CalibrationHistorySidebar"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const LoadingIndicator_1 = __importDefault(require("src/components/shared/LoadingIndicator/LoadingIndicator"));
/*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
*/
const areEqual = (prevProps, nextProps) => (0, isEqual_1.default)(prevProps, nextProps);
const CalibrationUserRow = react_1.default.memo(({ index, user, scoreAspectsHeader, configResult, isPerfCategory, cycleId, scoringMarks, currentCalibrator, isAbleToShowCurrentScore, setShowCalibrationSidebar, showCalibrationSidebar }) => {
    const queryClient = (0, react_query_2.useQueryClient)();
    const [showModalCalibrate, setShowModalCalibrate] = (0, react_1.useState)(false);
    const fetchUserList = () => {
        return (0, FormalReviewClient_1.getCalibrationTargetData)(cycleId, user?.placementId, {
            calibratorId: currentCalibrator?.id
        });
    };
    const { data } = (0, react_query_1.useQuery)(['calibration', user?.userId, user?.placementId], fetchUserList, {
        staleTime: 5 * 60 * 1000,
        initialData: { data: user }
    });
    const submitModal = async (targetId, targetPlacementId, newScore, comment, inputPerfCategory) => {
        const answers = {
            targetId: targetId,
            comment: comment,
            calibratorId: currentCalibrator?.id
        };
        if (isPerfCategory) {
            answers.performanceCategoryId = inputPerfCategory;
        }
        else {
            answers.score = newScore;
        }
        const { data } = await (0, FormalReviewClient_1.submitModalCalibrate)(cycleId, answers);
        if (data) {
            setShowModalCalibrate(false);
            // Beacuse BE did not support change isCalibrator dynamically according to the subscriber
            // currently BE only provide isCalibrator value from sender perspective
            // so we need to handle this manually in frontend
            // update isCalibrator manually when submit modal
            // and ignore isCalibrator from socket response
            updateIsCalibrator(targetId, targetPlacementId);
            sendSocketMessage('done');
        }
    };
    const updateIsCalibrator = (targetId, targetPlacementId) => {
        queryClient.setQueryData(['calibration', targetId, targetPlacementId], (oldData) => {
            if (!oldData)
                return {};
            return {
                ...oldData,
                data: { ...oldData?.data, isCalibrator: true }
            };
        });
    };
    const userData = data?.data;
    const ScoreTemplate = ({ score, name, showOption, color, isPerfCategoryTemplate }) => {
        return (react_1.default.createElement("div", { className: "text-celloverflow-hidden" },
            showOption != 'score_only' &&
                !isPerfCategoryTemplate &&
                name != '-' && (react_1.default.createElement("p", { className: "typography-h100 typography-heading typography-secondary", style: { color: `#${color}` } }, name) // e.g: Extraordinary or A+
            ),
            showOption != 'label_only' && score != '-' && (react_1.default.createElement("p", { className: "typography-h400 typography-paragraph text-n-900" }, typeof score == 'number' && score % 1 != 0
                ? score.toFixed(2)
                : score) // e.g: 3.40 or 6
            ),
            name == '-' && score == '-' && (react_1.default.createElement("p", { className: "typography-h400 typography-paragraph text-n-600" }, "--"))));
    };
    const renderScore = (score) => {
        if (!score)
            return '-';
        return score;
    };
    const handleSelectRow = async (e) => {
        e.stopPropagation();
        setShowCalibrationSidebar(userData?.userId);
    };
    const sendSocketMessage = (status) => {
        const listener = new socket_1.SocketListener();
        listener.sendAction({
            name: socket_1.SocketChannels.calibration(cycleId),
            action: 'target_status',
            data: {
                user_id: userData?.userId,
                placement_id: userData?.placementId,
                status: status,
                cycle_id: cycleId,
                calibrator_id: currentCalibrator?.id
            }
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Table_1.default.Row, { key: `user+${userData?.id}+row+${index}`, onClick: (e) => handleSelectRow(e) },
            react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+no` }, index + 1),
            react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+name` },
                react_1.default.createElement("div", { className: "flex items-center w-full" },
                    react_1.default.createElement("div", { className: "relative" },
                        react_1.default.createElement(Avatar_1.default, { size: 32, name: userData?.name }),
                        userData?.status == 'in_progress' ? (react_1.default.createElement("div", { className: "absolute right-0 bottom-0" },
                            react_1.default.createElement(TooltipContainer_1.default, { show: true, text: (0, HelperUtils_1.getObjectiveLocale)('Other is calibrating this user') },
                                react_1.default.createElement("div", { className: "bg-b-500 rounded-[12px] w-[12px] h-[12px] flex items-center justify-center border-[1px] border-solid border-n-000" },
                                    react_1.default.createElement(LoadingIndicator_1.default, { size: 2, gap: 1, color: "var(--n-000)" }))))) : (userData?.isCalibrate && (react_1.default.createElement("div", { className: "absolute bg-g-600 rounded-[50px] right-0 bottom-0" },
                            react_1.default.createElement(TooltipContainer_1.default, { show: true, text: (0, HelperUtils_1.getObjectiveLocale)('This user has already been calibrated') },
                                react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-refresh", size: 16, fillColor: "var(--n-000)" })))))),
                    react_1.default.createElement("div", { className: "flex flex-col ml-[8px] overflow-hidden" },
                        react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h400 typography-secondary" }, userData?.name || ''),
                        react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h100 typography-secondary" }, userData?.email || '')))),
            react_1.default.createElement(Table_1.default.Column, { customClass: "justify-center", key: `user+${userData?.id}+column+status` }, userData?.isCalibrator ? (react_1.default.createElement("div", { className: "bg-g-600 rounded-[50px] right-0 bottom-0" },
                react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-check", size: 16, fillColor: "var(--n-000)" }))) : (react_1.default.createElement(react_1.default.Fragment, null))),
            react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+manager` }, userData?.manager?.name || ''),
            scoreAspectsHeader.map(({ idAspect, widthClass }, index) => {
                const scoreAspect = userData?.score?.scoreAspects?.find((dt) => dt.id == idAspect);
                return (react_1.default.createElement(Table_1.default.Column, { widthClass: widthClass, key: `user+${userData?.id}+column+score-aspect-${index}` },
                    react_1.default.createElement(ScoreTemplate, { score: renderScore(scoreAspect?.score), name: scoreAspect?.statusName || '-', showOption: scoreAspect?.showOption, color: scoreAspect?.statusColorHex })));
            }),
            configResult?.finalResultVisible ? (react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+final` },
                react_1.default.createElement(ScoreTemplate, { score: renderScore(userData?.score?.final?.score), name: userData?.score?.final?.statusName || '-', showOption: userData?.score?.final?.showOption, color: userData?.score?.final?.statusColorHex }))) : (react_1.default.createElement(react_1.default.Fragment, null)),
            configResult?.finalPerformanceCategoryResultVisible ? (react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+category` },
                react_1.default.createElement(ScoreTemplate, { score: userData?.score?.finalPerformanceCategory
                        ?.performanceCategory || '-', name: userData?.score?.finalPerformanceCategory?.statusName || '-', showOption: userData?.score?.finalPerformanceCategory?.showOption, color: userData?.score?.finalPerformanceCategory?.statusColorHex, isPerfCategoryTemplate: isPerfCategory }))) : (react_1.default.createElement(react_1.default.Fragment, null)),
            react_1.default.createElement(Table_1.default.Column, { key: `user+${userData?.id}+column+icon` },
                react_1.default.createElement(TooltipContainer_1.default, { show: true, text: (0, HelperUtils_1.getObjectiveLocale)('Calibrate Now') },
                    react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-create", size: 24, fillColor: "var(--base-600)", onClick: () => {
                            sendSocketMessage('in_progress');
                            setShowModalCalibrate(true);
                        }, customClass: "invisible group-hover:visible", dataCy: "do-calibrate-score" })))),
        showModalCalibrate && userData && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        react_1.default.createElement(CalibrationModal_1.default, { userData: userData, cycleId: cycleId, closeModal: () => {
                sendSocketMessage('done');
                setShowModalCalibrate(false);
            }, submitModal: submitModal, scoringMarks: scoringMarks, isPerfCategory: isPerfCategory, calibrationModalLoading: false, currentCalibratorId: currentCalibrator?.id })),
        showCalibrationSidebar == userData?.userId && (react_1.default.createElement(CalibrationHistorySidebar_1.default, { cycleId: cycleId, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setShowCalibrationSidebar: setShowCalibrationSidebar, userData: userData, isPerfCategory: isPerfCategory, currentCalibrator: currentCalibrator, isAbleToShowCurrentScore: isAbleToShowCurrentScore }))));
}, areEqual);
CalibrationUserRow.displayName = 'CalibrationUserRow';
exports.default = CalibrationUserRow;
